import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConfigurationRoutingModule } from './configuration-routing.module';
import { CurrencyModule } from './currency/currency.module';
import { UserModule } from './user/user.module';
import { JobModule } from '../human-resources/job/job.module';
import { ExportHistoryModule } from './export-history/export-history.module';
import { VersionDetailsComponent } from './version/version-details/version-details.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AttendanceModule } from './attendance/attendance.module';

@NgModule({
  declarations: [VersionDetailsComponent],
  imports: [
    CommonModule,
    ConfigurationRoutingModule,
    CurrencyModule,
    UserModule,
    JobModule,
    ExportHistoryModule,
    TranslatePipe,
    AttendanceModule,
  ],
})
export class ConfigurationModule {}
